import React from 'react'
import { useIdleTimer } from 'react-idle-timer'
import {useLogoutMutation} from "../../apis/authenticationApi";
import {useNavigate} from "react-router-dom";

const IdleTimeout = () => {
    const [logout] = useLogoutMutation();
    const navigate = useNavigate();
    const handleOnIdle = async () => {
        await logout();

        navigate('/auth/login');
    }

    useIdleTimer({
        timeout: 1000 * 60 * 120,
        onIdle: handleOnIdle,
        debounce: 1000
    })

    return (
        <></>
    )
}

export default IdleTimeout;
